// extracted by mini-css-extract-plugin
export default {"content":"Kk0W7IiR","asset":"qAS9jwiI"};